import angular from 'angular';

export const JobListingAreaChart = () => {
    const getJobListingAreaChart = function (callback) {
        const dataSource = [{
            val: '0',
            s: 0,
        }, {
            val: '1',
            s: 2,
        }, {
            val: '2',
            s: 4,
        }, {
            val: '3',
            s: 12,
        }, {
            val: '4',
            s: 15,
        }, {
            val: '5',
            s: 25,
        }];

        const options = {
            palette: 'Harmony Light',
            dataSource,
            commonSeriesSettings: {
                type: 'area',
                argumentField: 'val',
                hoverMode: 'none',
                area: {
                    color: 'rgba(67, 98, 164, 0.25)',
                },
            },
            series: [
                { valueField: 's',
                    border: {
                        visible: true,
                        color: '#4362A4'
                    }
                },
            ],
            argumentAxis: {
                constantLineStyle: {
                    color: '#CE5C32',
                    width: 3,
                    label: {
                        visible: false,
                    },
                },
                label: {
                    visible: false,
                },
                constantLines: [
                    { value: '3' },
                ],
            },
            valueAxis: {
                label: {
                    visible: false,
                },
                grid: {
                    visible: false,
                },
            },
        };

        callback({
            options,
        });
    };

    return {
        getJobListingAreaChart,
    };
};

angular
    .module('TALENYA-FE')
    .factory('JobListingAreaChart', JobListingAreaChart);
